export default __webpack_public_path__ + "static/media/42.7b1fb255.jpg";